export const VISIT_FINALIZATION_DIALOG_TEXT = Object.freeze({
  fallbackVisitorName: 'o visitante',
  fallbackPropertyTitle: 'Imóvel da visita',
  fallbackValue: '—',
  titlePrefix: 'Sua visita com',
  titleSuffix: 'foi realizada?',
  primaryButton: 'Sim, a visita foi realizada',
  secondaryButton: 'Não, a visita não foi realizada',
  dateTimeTitle: 'Dia e horário',
  addressTitle: 'Endereço',
});

const toText = value => String(value || '').trim();

const firstPresent = (...values) =>
  values.find(value => value !== undefined && value !== null && value !== '');

export const formatVisitorFirstName = visitorName => {
  const name = toText(visitorName);
  return name.split(/\s+/).filter(Boolean)[0] || '';
};

export const visitFinalizationVisitorName = visit =>
  formatVisitorFirstName(
    firstPresent(
      visit?.contact?.name,
      visit?.contactName,
      visit?.contact_name,
      visit?.visitor?.name,
      visit?.visitorName,
      visit?.visitor_name
    )
  ) || VISIT_FINALIZATION_DIALOG_TEXT.fallbackVisitorName;

export const visitFinalizationDialogTitle = visit =>
  `${VISIT_FINALIZATION_DIALOG_TEXT.titlePrefix} ${visitFinalizationVisitorName(
    visit
  )} ${VISIT_FINALIZATION_DIALOG_TEXT.titleSuffix}`;

export const visitFinalizationPropertyTitle = visit =>
  firstPresent(
    visit?.imovel?.titulo,
    visit?.imovel?.title,
    visit?.imovel?.name,
    visit?.imovelTitle,
    visit?.imovel_title
  ) || VISIT_FINALIZATION_DIALOG_TEXT.fallbackPropertyTitle;
